import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import EditJobOpportunities from "./EditJobOpportunities";
import { DeleteJobOpportunitiesDuringProjectData } from "../../Redux/Reducers/ReportStage/JobOpportunitiesDuringProject";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../Services/apiService";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";

const JobOpportunitiesDuringProject = (props) => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [JobOppId, setJobOppId] = useState(null);
  const state = useSelector((state) => {
    return {
      
      jsonData: state.FetchDataJson.JsonData,
     
    };
  });

console.log(props.canEdit,"props.canEdit");

  const RequestAccessor = [
    {
      KeyName: "typeOfJobOpportunityName",
      ShowStatus: true,
      NmaeColumn: "نوع فرصة العمل",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "gender",
      ShowStatus: true,
      NmaeColumn: "الجنس",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "natureOfOpportunity",
      ShowStatus: true,
      NmaeColumn: "طبيعة الفرصة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setJobOppId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
        className: props.canEdit
          ? "bi bi-pencil-square"
          : "bi bi-view-list",
      // className: "bi bi-pencil-square",

      id: "editBtn",
      title: "عرض",
      ShowStatus:true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/JobOpportunitiesDuringProject/DeletePR_JobOpportunitiesDuringProjectData",
              {
                pR_JobOpportunitiesDuringProjectId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      // ShowStatus: !shouldDisableFields,
      ShowStatus: props.canEdit,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        <EditJobOpportunities />
      </div>
    ),
    title: "فرص العمل التي تم توفيرها خلال فترة المرحلة الحالية",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <EditJobOpportunities
          pR_JobOpportunitiesDuringProjectId={JobOppId}
          canEdit="edit"
          shouldDisableFields={!props.canEdit}
        />
      </div>
    ),
    title: "فرص العمل التي تم توفيرها خلال فترة المرحلة الحالية",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_JobOpportunitiesDuringProjectId"}
        valueButtonAction={"pR_JobOpportunitiesDuringProjectId"}
        URL={`api/JobOpportunitiesDuringProject/GetPR_JobOpportunitiesDuringProjectListData`}
        UrlBody={{
          pR_ReportsStagesGuid: props.pR_ReportsStagesGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"فرص العمل التي تم توفيرها خلال فترة المرحلة الحالية"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        // tableBtn={!shouldDisableFields}
        tableBtn={props.canEdit}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};

export default JobOpportunitiesDuringProject;
